module.exports = __webpack_public_path__ + "media/images/salespartner/bg-cta-right-0cf371c5974f3dd3ade1726a651db09a.svg";